import { capitalize } from 'lodash';

import { GuardianRecord } from '@ducat-unit/client-sdk';
import { NetworkSettings } from '@/context/DucatClientCtx';

export const getOptions = (guards: GuardianRecord[] | undefined, settings: NetworkSettings) => {
  return (
    guards?.map((guard, index) => ({
      label: `${capitalize(settings.network)} Guardian ${index + 1}`,
      value: guard.url,
      meta: guard,
    })) || []
  );
};

export const isMissingRequiredFields = ({
  masterId,
  customGuardian,
  guardianUrl,
  guardianPublicKey,
}: NetworkSettings): boolean=> {
  return !masterId || (!customGuardian && !guardianUrl) || (customGuardian && (!guardianUrl || !guardianPublicKey))
}

export function getRandomItem(list: any[]) {
  const randomIndex = Math.floor(Math.random() * list.length);
  return list[randomIndex];
}
